export function maudlib(): string {
  return 'maudlib';
}
